import { lazy } from 'react';
import { RouteWithoutLayout } from 'react-admin';
import { lazyRetry } from './utils/index';
import VerifyOtp from './views/auth/VerifyOtp'
import Login from './views/auth/Login'
import PasswordReset from './views/auth/PasswordReset'
import ChangePassword from './views/auth/ChangePassword'
import ChangePasswordTemporal from './views/auth/ChangePasswordTemporal'

// Views
//const Login = lazy(() => lazyRetry(() => import('./views/auth/Login')));
//const PasswordReset = lazy(() => lazyRetry(() => import('./views/auth/PasswordReset')));
//const ChangePassword = lazy(() => lazyRetry(() => import('./views/auth/ChangePassword')));
//const ChangePasswordTemporal = lazy(() => lazyRetry(() => import('./views/auth/ChangePasswordTemporal')));
//const VerifyOtp = lazy(() => lazyRetry(() => import('./views/auth/VerifyOtp')));


const routes = [
  // No Authenticated
  <RouteWithoutLayout exact path="/reset-password" component={PasswordReset} />,
  <RouteWithoutLayout exact path="/change-password" component={ChangePassword} />,
  <RouteWithoutLayout exact path="/login" component={Login} />,
  <RouteWithoutLayout exact path="/change-password-temp" component={ChangePasswordTemporal} />,
  <RouteWithoutLayout exact path="/verify-otp" component={VerifyOtp} />,
]

export default routes